// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"94d3b5bc","72":"744c19ac","112":"9e4d7140","132":"f37d08d2","149":"354a2f4b","264":"8016cd5d","272":"470c8354","292":"cd57f936","328":"f0c53ab3","375":"5601970a","444":"10b8ac7a","807":"04412b27"}[chunkId] + ".chunk.js";
};